module.exports = __webpack_public_path__ + "static/logo_transparent-17b4a1a1a44b233e6d55eea494d96fa4.png";